import { render, staticRenderFns } from "./purchaseListOrderTemplate.vue?vue&type=template&id=b7dc7e92&scoped=true"
import script from "./purchaseListOrderTemplate.vue?vue&type=script&lang=js"
export * from "./purchaseListOrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./purchaseListOrderTemplate.vue?vue&type=style&index=0&id=b7dc7e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dc7e92",
  null
  
)

export default component.exports